import apiClient from "./axiosConfig";

const LOW_STOCK_PATH = "/dashboard/low-stock/";
const TOP_CREDIT_CUSTOMERS_PATH = "/dashboard/top-credit-customers/";
const TOP_PURCHASE_CUSTOMERS_PATH = "/dashboard/top-purchase-customers/";
const TOP_PRODUCT_BRAND_PATH = "/dashboard/top-product-brand/";
const KPI_SUMMARY_PATH = "/dashboard/kpi-summary/";
const SALES_OVERVIEW_PATH = "/dashboard/sales-overview/";
const USER_PERFORMANCE_PATH = "/dashboard/user-performance/";

export const getList = async ({ page, size }) => {
  return apiClient({
    method: "get",
    url: `/dashboard/?page=${page}&size=${size}`,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const getLowStockAlerts = async () => {
  try {
    const url = process.env.REACT_APP_API_URL
      ? LOW_STOCK_PATH
      : `https://api.buyphone24.com/api${LOW_STOCK_PATH}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard low stock alerts:", error);
    throw error;
  }
};

export const getTopCreditCustomers = async () => {
  try {
    const url = process.env.REACT_APP_API_URL
      ? TOP_CREDIT_CUSTOMERS_PATH
      : `https://api.buyphone24.com/api${TOP_CREDIT_CUSTOMERS_PATH}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching top credit customers:", error);
    throw error;
  }
};

export const getTopPurchaseCustomers = async () => {
  try {
    const url = process.env.REACT_APP_API_URL
      ? TOP_PURCHASE_CUSTOMERS_PATH
      : `https://api.buyphone24.com/api${TOP_PURCHASE_CUSTOMERS_PATH}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching top purchase customers:", error);
    throw error;
  }
};

export const getTopProductBrand = async () => {
  try {
    const url = process.env.REACT_APP_API_URL
      ? TOP_PRODUCT_BRAND_PATH
      : `https://api.buyphone24.com/api${TOP_PRODUCT_BRAND_PATH}`;
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching top product/brand:", error);
    throw error;
  }
};

export const getKpiSummary = async (filter, customParams = {}) => {
  try {
    let params = {};
    
    // If custom date range is provided, use it
    if (customParams.start_date && customParams.end_date) {
      params = {
        start_date: customParams.start_date,
        end_date: customParams.end_date,
      };
    } else if (filter) {
      // Otherwise use the filter_date parameter
      params = { filter_date: filter };
    }
    
    const url = process.env.REACT_APP_API_URL
      ? KPI_SUMMARY_PATH
      : `https://api.buyphone24.com/api${KPI_SUMMARY_PATH}`;
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching KPI summary:", error);
    throw error;
  }
};

export const getSalesOverview = async (filter = "last_7_days", customParams = {}) => {
  try {
    let params = {};
    
    // If custom date range is provided, use it
    if (customParams.start_date && customParams.end_date) {
      params = {
        start_date: customParams.start_date,
        end_date: customParams.end_date,
      };
    } else if (filter) {
      // Otherwise use the filter_date parameter
      params = { filter_date: filter };
    }
    
    const url = process.env.REACT_APP_API_URL
      ? SALES_OVERVIEW_PATH
      : `https://api.buyphone24.com/api${SALES_OVERVIEW_PATH}`;
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching sales overview:", error);
    throw error;
  }
};

export const getUserPerformance = async (filter = "last_7_days", customParams = {}) => {
  try {
    let params = {};
    
    // If custom date range is provided, use it
    if (customParams.start_date && customParams.end_date) {
      params = {
        start_date: customParams.start_date,
        end_date: customParams.end_date,
      };
    } else if (filter) {
      // Otherwise use the filter_date parameter
      params = { filter_date: filter };
    }
    
    const url = process.env.REACT_APP_API_URL
      ? USER_PERFORMANCE_PATH
      : `https://api.buyphone24.com/api${USER_PERFORMANCE_PATH}`;
    const response = await apiClient.get(url, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching user performance:", error);
    throw error;
  }
};

